import React from 'react' // do not remove because transpiled JS will break for PDF - TK
import PropTypes from 'prop-types'
import MarkdownIt from 'markdown-it'

const markdown = new MarkdownIt({
  html: true,
  linkify: true
})

export default class MarkdownText extends React.Component {
  render() {
    if (this.props.displayText) {
      return (
        <div
          className='markdown-text'
          dangerouslySetInnerHTML={{__html: markdown.render(this.props.displayText).trim()}}
        />
      )
    } else {
      return null
    }
  }
}

MarkdownText.propTypes = {
  displayText: PropTypes.string
}
